import { WORK_MANAGEMENT_MINI_SITE_LINK, CRM_MINI_SITE_LINK, SOFTWARE_MINI_SITE_LINK, SERVICE_MINI_SITE_LINK, CANVAS_HOMEPAGE_LINK, CAMPAIGNS_MINI_SITE_LINK, MONDAY_VIBE_HEADER_LINK, MONDAY_AGENTS_HEADER_LINK, MONDAY_SIDEKICK_HEADER_LINK } from "constants/links";
export const SIDEKICK_NAME = "Sidekick";
export const VIBE_NAME = "Vibe";
export const AGENTS_NAME = "Agents";
export const MAIN_PRODUCTS = [
    {
        name: "header.tabs.solutions.byProduct.workManagement",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/WM.svg",
        miniSiteLink: WORK_MANAGEMENT_MINI_SITE_LINK,
        exitingAccountPath: "/account_products/direct_install/core"
    },
    {
        name: "header.tabs.solutions.byProduct.crm",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/CRM.svg",
        miniSiteLink: CRM_MINI_SITE_LINK,
        exitingAccountPath: "/account_products/direct_install/crm"
    },
    {
        name: "header.tabs.solutions.byProduct.dev",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/DEV.svg",
        miniSiteLink: SOFTWARE_MINI_SITE_LINK,
        exitingAccountPath: "/account_products/direct_install/software"
    },
    {
        name: "header.tabs.solutions.byProduct.campaigns",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/monday-crm/assets/email-marketing-project/campaigns-logo-square.png",
        miniSiteLink: CAMPAIGNS_MINI_SITE_LINK,
        exitingAccountPath: "/account_products/direct_install/marketing_campaigns"
    },
    {
        name: "header.tabs.solutions.byProduct.service",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/SVC.svg",
        miniSiteLink: SERVICE_MINI_SITE_LINK,
        exitingAccountPath: "/account_products/direct_install/service"
    }
];
export const ADDITIONAL_PRODUCTS = [
    {
        name: "WorkCanvas",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/workcanvas_with_background_yokpva.svg",
        miniSiteLink: CANVAS_HOMEPAGE_LINK
    }
];
export const AI_SOLUTIONS = [
    {
        name: SIDEKICK_NAME,
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/sidekick_white_icon_x0dwnv.svg",
        miniSiteLink: MONDAY_SIDEKICK_HEADER_LINK,
        exitingAccountPath: "/sidekick"
    },
    {
        name: VIBE_NAME,
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/vibe_white_icon_sge8pn.svg",
        miniSiteLink: MONDAY_VIBE_HEADER_LINK,
        exitingAccountPath: "/vibe"
    },
    {
        name: AGENTS_NAME,
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/agents_white_icon_smp2ag.svg",
        miniSiteLink: MONDAY_AGENTS_HEADER_LINK,
        exitingAccountPath: "/ai_agents",
        hasEarlyAccessTag: true
    }
];
